import IntlMessages from 'helpers/IntlMessages'

export const SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_PREFIX = 'SC'

const SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE = {
  adminAndSetting: 'admin_and_setting',
  vehicleAndPers: 'vehicle_and_pers',
  configuration: 'configuration',
  marketing: 'marketing',
  additionalPermission: 'additional_permission',
  developers: 'developers'
}

export const SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_ORDER = [
  SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE.vehicleAndPers,
  SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE.configuration,
  SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE.marketing,
  SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE.adminAndSetting,
  SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE.developers,
  SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE.additionalPermission
]

export const SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_LABEL = {
  [SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE.adminAndSetting]: (
    <IntlMessages id="company_category_role.admin_and_settings" />
  ),
  [SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE.vehicleAndPers]: (
    <IntlMessages id="company_category_role.vehicle_and_pers" />
  ),
  [SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE.configuration]: (
    <IntlMessages id="company_category_role.configuration" />
  ),
  [SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE.marketing]: (
    <IntlMessages id="company_category_role.marketing" />
  ),
  [SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE.developers]: (
    <IntlMessages id="company_category_role.developers" />
  ),
  [SERVICE_CENTER_PLATFORM_PARENT_CATEGORY_PERMISSION_CODE.additionalPermission]:
    <IntlMessages id="company_category_role.additional_permission" />
}

export const SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX = {
  // Vehicle & Pers
  vehicles: 'Vehicles',
  pers: 'Pers',
  ownershipTransfer: 'OwnershipTransfer',
  persOwnershipTransfer: 'PersOwnershipTransfer',
  digitalKeys: 'DigitalKeys',
  digitalKey: 'DigitalKey',

  // Configuration
  persToVehicle: 'PersToVehicle',
  vehicleModels: 'VehicleModels',
  configurationPersUpdate: 'ConfigurationPersUpdate',
  persDiagnostics: 'PersDiagnostics',

  // PERS Repair
  persRepair: 'PersRepair',
  persKit: 'PersKit',

  // Marketing
  riders: 'Riders',

  // Admin & Settings
  companyProfileInformation: 'CompanySCfile_Information',
  userManagement: 'UserManagement',
  teamRolesConfiguration: 'TeamRolesConfiguration',
  teamRoles: 'TeamRoles',
  manageSubscription: 'ManageSubscription',
  fleetNodes: 'FleetNodes',
  geolocation: 'Geolocation',
  subcontractors: 'Subcontractors',
  subcontractorBrands: 'Subcontractor_Brands',
  subcontractorPers: 'Subcontractor_PERS',
  subcontractorMembers: 'Subcontractor_Members',
  dealers: 'Dealers',
  dealerMembers: 'Dealer_Members',
  dealerVehicles: 'Dealer_Vehicles',
  manufacturers: 'Manufacturers',

  // Developers
  publicAPIs: 'PublicAPIs',

  // Additional Permission
  homepage: 'Homepage'
}

export const SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_LABEL_MAPPING = {
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.pers]: 'Pers',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.vehicles]:
    'Vehicles',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.ownershipTransfer]:
    'Ownership Transfer',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.persOwnershipTransfer]:
    'Ownership Transfer — Manage',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.digitalKeys]:
    'Digital Keys',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.digitalKey]:
    'Digital Keys',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.persToVehicle]:
    'PERS To Vehicle',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.vehicleModels]:
    'Manage Vehicles',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.configurationPersUpdate]:
    'Configuration PERS Update',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.persDiagnostics]:
    'PERS Diagnostics',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.persRepair]:
    'PERS Repair',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.persKit]: 'PERS Kit',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.riders]: 'Riders',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.companyProfileInformation]:
    'Company Profile',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.userManagement]:
    'User Management',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.teamRoles]:
    'Team Roles',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.teamRolesConfiguration]:
    'Team Roles Configuration',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.manageSubscription]:
    'Manage Subscription',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.fleetNodes]:
    'Fleet Nodes',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.geolocation]:
    'Geolocation',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.subcontractors]:
    'Subcontractors',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.subcontractorBrands]:
    'Subcontractors',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.subcontractorPers]:
    'Subcontractors',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.subcontractorMembers]:
    'Subcontractors',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.dealers]: 'Dealers',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.dealerMembers]:
    'Dealers',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.dealerVehicles]:
    'Dealers',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.manufacturers]:
    'Manufacturers',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.publicAPIs]:
    'Public APIs',
  [SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_SUFFIX.homepage]:
    'Additional Permission'
}
